// eslint-disable-next-line no-restricted-imports
import {
  ActionButton as SpectrumActionButton,
  Avatar as SpectrumAvatar,
  Button as SpectrumButton,
  ComboBox as SpectrumComboBox,
  Content as SpectrumContent,
  Flex as SpectrumFlex,
  Form as SpectrumForm,
  Grid as SpectrumGrid,
  Header as SpectrumHeader,
  Heading as SpectrumHeading,
  IllustratedMessage as SpectrumIllustratedMessage,
  Item as SpectrumItem,
  LabeledValue as SpectrumLabeledValue,
  Link as SpectrumLink,
  Menu as SpectrumMenu,
  MenuTrigger as SpectrumMenuTrigger,
  Picker as SpectrumPicker,
  ProgressCircle as SpectrumProgressCircle,
  Provider as SpectrumProvider,
  SearchField as SpectrumSearchField,
  Section as SpectrumSection,
  Switch as SpectrumSwitch,
  TabList as SpectrumTabList,
  TabPanels as SpectrumTabPanels,
  Tabs as SpectrumTabs,
  Text as SpectrumText,
  TextArea as SpectrumTextArea,
  TextField as SpectrumTextField,
  ToastContainer as SpectrumToastContainer,
  ToastQueue as SpectrumToastQueue,
  ToggleButton as SpectrumToggleButton,
  View as SpectrumView,
  ActionGroup as SpectrumActionGroup,
  Divider as SpectrumDivider,
} from "@adobe/react-spectrum"

export const ActionButton = SpectrumActionButton
export const Avatar = SpectrumAvatar
export const Button = SpectrumButton
export const Flex = SpectrumFlex
export const Form = SpectrumForm
export const Header = SpectrumHeader
export const Item = SpectrumItem
export const Menu = SpectrumMenu
export const MenuTrigger = SpectrumMenuTrigger
export const SearchField = SpectrumSearchField
export const Switch = SpectrumSwitch
export const TabList = SpectrumTabList
export const TabPanels = SpectrumTabPanels
export const Tabs = SpectrumTabs
export const Text = SpectrumText
export const TextArea = SpectrumTextArea
export const TextField = SpectrumTextField
export const ThemeProvider = SpectrumProvider
export const View = SpectrumView
export const Picker = SpectrumPicker
export const ToastContainer = SpectrumToastContainer
export const ToastQueue = SpectrumToastQueue
export const Grid = SpectrumGrid
export const Content = SpectrumContent
export const Heading = SpectrumHeading
export const IllustratedMessage = SpectrumIllustratedMessage
export const ComboBox = SpectrumComboBox
export const LabeledValue = SpectrumLabeledValue
export const Section = SpectrumSection
export const ToggleButton = SpectrumToggleButton
export const ProgressCircle = SpectrumProgressCircle
export const Link = SpectrumLink
export const ActionGroup = SpectrumActionGroup
export const Divider = SpectrumDivider